import { codingbarApi } from 'codingbar-api';

import { getUUID } from 'shared/util/utils';

import { AIA_USERS_COLLECTION } from './collections';

export const getAIAUser = (uid) => {
	if (!uid) return Promise.reject('getAIAUser: wrong uid');

	const filter = {
		registed_uid: uid,
	};

	const projection = {
		id: 1,
		uid: 1,
		email: 1,
		unit: 1,
		role: 1,
		registed_uid: 1,
		registed_email: 1,
	};

	return codingbarApi
		.getCoreService()
		.queryOne(AIA_USERS_COLLECTION, filter, projection)
		.then((res) => {
			return res.status === 'success' ? res.result : undefined;
		})
		.catch((err) => console.error(err));
};

/** 新增 AIA 帳號對照 table
 * userObj
 * {
 *  id: string,
 *  uid: string, // 轉換成 uuid email 的 uid, 帳號唯一識別
 *  email: string, //轉換成 uuid email 的 email, 用來 render 帳號用
 *  registed_uid: string, // 註冊時輸入的 email 轉換成 uuid
 *  registed_email: string, // 註冊時輸入的 email
 *  role: string, // 帳號身份
 *  created_at: number, // 建立時間
 * }
 **/
export const createAIAUser = (userObj) => {
	if (!userObj) return Promise.reject('createAIAUser: wrong userObj');

	userObj.id = `${getUUID()}-${Date.now()}`;

	return codingbarApi
		.getCoreService()
		.createData(AIA_USERS_COLLECTION, userObj)
		.then((res) => {
			return res.status === 'success' ? res.result : undefined;
		})
		.catch((err) => console.error(err));
};

export const removeAIAUser = (uid) => {
	if (!uid) return Promise.reject('removeAIAUser: wrong uid');

	const filter = {
		uid,
	};

	return codingbarApi
		.getCoreService()
		.removeData(AIA_USERS_COLLECTION, filter)
		.then((res) => {
			return res.status === 'success' ? res.result : undefined;
		})
		.catch((err) => console.error(err));
};

export const getExistAIAUsers = (uidList) => {
	if (!uidList) return Promise.reject(new Error('getExistAIAUsers: wrong uidList'));
	if (!uidList.length) return Promise.resolve([]);

	const filter = {
		registed_uid: { $in: uidList },
	};

	const projection = {
		'_id': 0,
		'_ip': 0,
	};

	return codingbarApi
		.getCoreService()
		.queryData(AIA_USERS_COLLECTION, filter, {}, projection)
		.then((res) => {
			return res.status === 'success' ? res.result : undefined;
		});
};

export const getAIAUserUidCache = () => {
	return localStorage.getItem('AIAUserUid');
};

export const setAIAUserUidCache = (uid) => {
	return localStorage.setItem('AIAUserUid', uid);
};

// export const getExistAIAUserByCourseId = (courseId) => {
// 	if (!courseId) return Promise.reject(new Error('getExistAIAUserByCourseId: courseId isEmpty'));

// 	const filter = {
// 		'testEvent.courseId': courseId,
// 	};

// 	const projection = {
// 		displayName: 1,
// 		email: 1,
// 	};

// 	return codingbarApi
// 		.getCoreService()
// 		.queryOne(AIA_USERS_COLLECTION, filter, projection)
// 		.then((res) => {
// 			return res.status === 'success' ? res.result : undefined;
// 		});
// };

// export const getExistAIAUserByEventId = (eventId) => {
// 	if (!eventId) return Promise.reject(new Error('getExistAIAUserByEventId: eventId isEmpty'));

// 	const filter = {
// 		'testEvent.eventId': eventId,
// 	};

// 	const projection = {
// 		displayName: 1,
// 		email: 1,
// 	};

// 	return codingbarApi
// 		.getCoreService()
// 		.queryOne(AIA_USERS_COLLECTION, filter, projection)
// 		.then((res) => {
// 			return res.status === 'success' ? res.result : undefined;
// 		});
// };

// export const getAIAUserByEventId = (courseId, eventId) => {
// 	if (!courseId) return Promise.reject(new Error('getAIACUser: wrong courseId'));
// 	if (!eventId) return Promise.reject(new Error('getAIAUser: wrong eventId'));

// 	const filter = {
// 		'testEvent.courseId': courseId,
// 		'testEvent.eventId': eventId,
// 	};

// 	const projection = {};

// 	return codingbarApi
// 		.getCoreService()
// 		.queryData(AIA_USERS_COLLECTION, filter, {}, projection)
// 		.then((res) => {
// 			return res.status === 'success' ? res.result : undefined;
// 		});
// };
